import { render, staticRenderFns } from "./giveLesson-screen.vue?vue&type=template&id=701422a1&scoped=true"
import script from "./giveLesson-screen.vue?vue&type=script&lang=js"
export * from "./giveLesson-screen.vue?vue&type=script&lang=js"
import style0 from "./giveLesson-screen.vue?vue&type=style&index=0&id=701422a1&lang=scss&scoped=true"
import style1 from "./giveLesson-screen.vue?vue&type=style&index=1&id=701422a1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701422a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('701422a1')) {
      api.createRecord('701422a1', component.options)
    } else {
      api.reload('701422a1', component.options)
    }
    module.hot.accept("./giveLesson-screen.vue?vue&type=template&id=701422a1&scoped=true", function () {
      api.rerender('701422a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsteacher/teacher/giveLesson-screen.vue"
export default component.exports